import { axiosInstance as axios } from "services";

export const processAllPendingPriceChanges = async () => {
  const { data } = await axios.post("/admin/subscription/global-price-change/process-all");
  if (!data.success) throw new Error(data.error?.message || "Failed to process pending price changes");
  return data;
};

